<template>
  <div :menu-fix="true">
    <div class="wrapper">
      <breadcrumb :crumbs="[$t('menu.reports'), $t('reports.supplierOver')]">
      </breadcrumb>
    </div>
    <div class="search">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
        label-width="100px"
      >
        <el-form-item
          :label="$t('workOrder.placeAt')"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('order.giveAt')]),
              trigger: 'blur',
            },
          ]"
        >
          <date-range
            v-model="searchForm"
            type="datetime"
            field="placeAt"
            :start-placeholder="$t('text.startAt')"
            :end-placeholder="$t('text.endAt')"
          />
        </el-form-item>
        <br />

        <el-form-item :label="$t('menu.suppliers')">
          <el-checkbox-group v-model="searchForm.supplierIds">
            <el-checkbox
              v-for="(supplier, index) of suppliers"
              :key="index"
              :label="supplier.id"
              >{{ supplier.name }}</el-checkbox
            >
          </el-checkbox-group>
        </el-form-item>
        <br />
        <el-form-item :label="' '">
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
            >{{ $t("text.search") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <vxe-table
        :data="records"
        :loading="loading"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="supplierName"
          :title="$t('menu.suppliers')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.supplierName }}
          </template>
        </vxe-table-column>
        <vxe-table-column field="total" :title="'超期单数'" min-width="80" />
        <vxe-table-column field="over1" :title="'超期一天单数'" min-width="80">
          <template v-slot="{ row }">
            <span
              v-if="row.supplierName != '合计'"
              class="blue"
              @click="detail(row, '1')"
            >
              {{ row.over1 }}
            </span>
            <span v-else>{{ row.over1 }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="over2" :title="'超期两天单数'" min-width="80">
          <template v-slot="{ row }">
            <span
              v-if="row.supplierName != '合计'"
              class="blue"
              @click="detail(row, '2')"
            >
              {{ row.over2 }}
            </span>
            <span v-else>{{ row.over2 }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column field="over3" :title="'超期三天单数'" min-width="80">
          <template v-slot="{ row }">
            <span
              v-if="row.supplierName != '合计'"
              class="blue"
              @click="detail(row, '3')"
            >
              {{ row.over3 }}
            </span>
            <span v-else>{{ row.over3 }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column field="over4" :title="'超期四天单数'" min-width="80">
          <template v-slot="{ row }">
            <span
              v-if="row.supplierName != '合计'"
              class="blue"
              @click="detail(row, '4')"
            >
              {{ row.over4 }}
            </span>
            <span v-else>{{ row.over4 }}</span>
          </template>
        </vxe-table-column>

        <vxe-table-column field="over5" :title="'超期五天单数'" min-width="80">
          <template v-slot="{ row }">
            <span
              v-if="row.supplierName != '合计'"
              class="blue"
              @click="detail(row, '5')"
            >
              {{ row.over5 }}
            </span>
            <span v-else>{{ row.over5 }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="overMore"
          :title="'超期更多天数'"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span
              v-if="row.supplierName != '合计'"
              class="blue"
              @click="detail(row, 'more')"
            >
              {{ row.overMore }}
            </span>
            <span v-else>{{ row.overMore }}</span>
          </template>
        </vxe-table-column>
      </vxe-table>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import Supplier from "@/api/supplier";
import Purchase from "@/api/purchase";

export default {
  mixins: [page, table.pager, table.search],
  components: { DateRange },
  data() {
    return {
      searchForm: {
        placeAtStartAt: null,
        placeAtEndAt: null,

        supplierIds: [],
      },
      suppliers: [],
      //
      records: [],
      loading: false,
    };
  },

  created() {
    const self = this;
    axios.all([Supplier.findByTenantId()]).then(
      axios.spread(function (suppliers) {
        if (suppliers.status == 200) {
          self.suppliers = suppliers.data;
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    detail(row, data) {
      const self = this;
      let obj = self.combineParams();
      obj["overDay"] = data;
      obj["supplierId"] = row.supplierId;

      self.$router.push({
        name: "fnReportsReportsPmsSupplierOverDetail",
        query: obj,
      });
    },
    //
    loadData() {
      const self = this;
      if (self.searchForm.placeAtStartAt == null) {
        this.$message({
          message: self.$t("rules.select", [self.$t("workOrder.placeAt")]),
          type: "warning",
        });
        return;
      }
      self.loading = true;
      Purchase.supplierOverReport(self.combineParams()).then(function (res) {
        self.loading = false;
        if (res.status === 200) {
          self.records = res.data;
        } else {
          self.sysError();
        }
      });
    },
    //
    combineParams() {
      let params = {};
      if (this.pager) {
        params.currentPage = this.pager.currentPage;
        params.pageSize = this.pager.pageSize;
      }
      if (this.searchForm) {
        for (let key in this.searchForm) {
          if (
            this.searchForm[key] &&
            JSON.stringify(this.searchForm[key]) != "[]"
          ) {
            params[key] = this.searchForm[key];
          }
        }
      }
      return params;
    },
  },
};
</script>
<style >
.el-form-item__content {
  height: auto !important;
}
</style>